export default {
help: {
  faq: "Soalan Lazim",
  promo: "Promosi",
  contact: "Hubungi Kami",
  community: "Sertai komuniti kami",
  help: "Bantuan"
}
};
